import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function SubpageHero({ title, intro, images = [], ctaLink = '/kontakt', ctaText = 'Kontakt os' }) {
  const heroImage = images && images.length > 0 ? images[0] : null

  if (!heroImage) {
    return null
  }

  // Apply Cloudflare image resizing for performance
  const resizedUrl = heroImage.startsWith('https://assets.auxodev.dk')
    ? heroImage.replace('https://assets.auxodev.dk/assets/', 'https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/')
    : heroImage

  return (
    <section className="relative min-h-[380px] md:min-h-[450px] flex items-center overflow-hidden bg-brand-navy text-white py-20 md:py-28">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src={resizedUrl}
            alt={title}
            className="w-full h-full object-cover object-center scale-105"
            loading="eager"
          />
        </div>
        {/* Dark Overlay for perfect contrast and legibility */}
        <div className="absolute inset-0 bg-brand-navy/75 z-20" />
      </div>

      {/* Content */}
      <div className="mx-auto max-w-7xl px-6 relative z-30 w-full text-left">
        <h1 className="text-3xl md:text-5xl font-bold tracking-tight mt-2 max-w-4xl leading-tight">
          {title}
        </h1>
        {intro && (
          <p className="mt-4 text-base md:text-lg text-slate-300 max-w-2xl leading-relaxed">
            {intro}
          </p>
        )}
        {ctaLink && ctaText && (
          <div className="mt-8">
            <Link
              to={ctaLink}
              className="inline-block bg-white text-brand-navy hover:bg-slate-100 px-6 py-3.5 text-xs font-bold tracking-wider transition-all duration-200 shadow-sm hover:shadow"
            >
              {ctaText}
            </Link>
          </div>
        )}
      </div>
    </section>
  )
}
